import { Play, RotateCcw } from "lucide-react";
import { demoPresets, initialCabinState } from "../../config/demoPresets";
import { ActionButton } from "../design-system/ActionButton";
import type { CabinState, DemoPreset } from "../../types/domain";

export function ScriptControls({
  onPreset,
  onReset
}: {
  onPreset: (preset: DemoPreset) => void;
  onReset: () => void;
}) {
  return (
    <div className="script-controls" aria-label="演示脚本">
      {demoPresets.map((preset) => (
        <ActionButton
          key={preset.id}
          icon={<Play size={15} />}
          onClick={() => onPreset(preset)}
          title={preset.description}
        >
          {preset.title}
        </ActionButton>
      ))}
      <ActionButton icon={<RotateCcw size={15} />} variant="ghost" onClick={onReset}>
        重置
      </ActionButton>
    </div>
  );
}

export function applyPreset(state: CabinState, preset: DemoPreset): CabinState {
  return {
    ...initialCabinState,
    ...preset.statePatch
  };
}
